<template>
	<div class="bottom">
		<div class="bottom_box bm bm-ac bm-pc">
			<el-row :gutter="24">
				<el-col :span="4">
					<div class="grid-content" />
					<img class="logo" src="@/assets/runzhong_bottom_logo.png" @click="toPage('/')" alt="">
				</el-col>
				<el-col :span="3">
					<div class="bottom_title" @click="toPage('/about/company')">关于润众制药</div>
					<div class="bottom_item" @click="toPage('/about/company')">企业概况</div>
					<div class="bottom_item" @click="toPage('/about/history')">发展历程</div>
				</el-col>
				<el-col :span="3">
					<div class="bottom_title" @click="toPage('/news')">新闻与媒体</div>
				</el-col>
				<el-col :span="3">
					<div class="bottom_title" @click="toPage('/products/active')">产品服务</div>
					<div class="bottom_item" @click="toPage('/products/active')">化学原料药</div>
					<div class="bottom_item" @click="toPage('/products/inter')">化药中间体</div>
					<div class="bottom_item" @click="toPage('/products/bioDrug')">生物药</div>
					<div class="bottom_item" @click="toPage('/products/bioDrugIntermediate')">生物药中间体</div>
					<div class="bottom_item" @click="toPage('/products/bioEnzyme')">生物催化酶</div>
					<div class="bottom_item" @click="toPage('/products/ref')">对照品</div>
					<div class="bottom_item" @click="toPage('/products/cmo')">CMO/CDMO业务</div>
				</el-col>
				<el-col :span="3">
					<div class="bottom_title" @click="toRecruitPage">招贤纳士</div>
				</el-col>
				<el-col :span="3">
					<div class="bottom_title" @click="toPage('/contact')">联系我们</div>
				</el-col>
				<el-col :span="3">
					<div class="bottom_title" style="cursor: default">友情链接</div>
					<div class="bottom_item" @click="toExternalPage('https://www.cttq.com')">正大天晴官网</div>
					<div class="bottom_item" @click="toExternalPage('https://www.sinobiopharm.com')">中国生物制药官网</div>
				</el-col>
			</el-row>
		</div>
		<div class="bottom_bottom bm bm-ac bm-pc">
			正大天晴药业集团股份有限公司 版权所有 2009 | 苏 ICP 备 05004426 号 药品信息服务 (苏)- 非经营性 - 2013-0066
		</div>
	</div>
</template>
<script setup lang="ts">
	const router = useRouter()
	const toPage = (url) => {
		router.push(url)
	}
	// 跳转招贤纳士页面
	const toRecruitPage = () => {
		console.log(configData?.value?.recruit_url[0], "跳转链接")
		window.open(configData?.value?.recruit_url[0])
	}

	// 跳转外部页面
	const toExternalPage = (url) => {
		console.log(url, "跳转链接")
		window.open(url)
	}


	// 获取配置信息
	import { useConfigStore } from "@/stores/index.ts";
	const store = useConfigStore()
	const configData = computed(() => {
		console.log(store.configData,"store.configData")
		return store.configData
	})

</script>
<style lang="styl" scoped>
.bottom{
	width 100%
	height 215px
	background-color #222222
	min-width 1200px
	.bottom_box{
		width 100%
		padding 24px 0
		border-bottom 1px solid #3B3B3B
		.logo{
			width 102px
			height 27px
			cursor: pointer;
		}
		.bottom_title{
			font-size 12px
			line-height 12px
			color #fff
			margin-bottom 22px
			cursor: pointer;
		}
		.bottom_item{
			font-size 10px
			line-height 10px
			color #909090
			margin-bottom 12px
			cursor: pointer;
		}
		.el-row {
			width 80%
		}
	}
	.bottom_bottom{
		width 100%
		height 47px
		font-size 10px
		line-height 10px
		color #909090
	}
}
</style>